import React from "react";

const PreviewIframe = ({ id }: { id: string }) => {
  return <iframe sandbox={"allow-scripts"} scrolling={"no"} loading={"lazy"} src={`https://ordinals.com/preview/${id}`} />;
};

export default PreviewIframe;
